import React, { useEffect, useState } from 'react';

// LOCAL COMPONENTS
import Error from './Error';

// STYLES
import styles from './image.module.scss';

export default function ImageComponent({ fileName, fileUrl, onError }) {
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    const image = new Image();
    image.src = fileUrl;
    image.onerror = err => {
      onError();
      setShowError(true);
      // eslint-disable-next-line no-console
      console.error(`${err.message || 'Error'}:`, err);
    };
  }, [fileUrl, onError]);

  return showError ? (
    <Error
      message={
        <>
          Error displaying this image. Please{' '}
          <a download={fileName} href={fileUrl}>
            download
          </a>{' '}
          to view and print.
        </>
      }
    />
  ) : (
    <div className="text-center">
      <a
        className="d-block"
        download={fileName}
        href={fileUrl}
        onClick={() => setTimeout(() => window.URL.revokeObjectURL(fileUrl), 100)}
      >
        <img src={fileUrl} className={styles.img} alt="" />
      </a>
    </div>
  );
}
